import React from "react";
import ContentWrapper from "../../components/layout/ContentWrapper";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import { PageHeading } from "../../components";
import ChangePasswordForm, {
  ChangePasswordFormValues,
} from "../../components/forms/password/ChangePasswordForm";
import LanguageSwitcher from "../../components/languageSwitcher/LanguageSwitcher";
import customerUserClient from "../../api/private/customerUserClient";

const SettingsPage: React.FC = (): React.ReactElement => {
  const { t, tCommon } = useCustomTranslation();

  const handleChangePassword = async (values: ChangePasswordFormValues) =>
    await customerUserClient.changePassword(values);

  return (
    <ContentWrapper htmlTitle={t("settings")}>
      <PageHeading title={t("settings")} className="mb-6" />
      <div className="flex flex-col gap-4 sm:flex-row sm:gap-8">
        <div>
          <p className="mb-2 text-sm font-bold uppercase">
            {tCommon("change_password")}
          </p>
          <ChangePasswordForm onSubmit={handleChangePassword} />
        </div>
        <div>
          <p className="mb-2 text-sm font-bold uppercase">
            {tCommon("change_language")}
          </p>
          <LanguageSwitcher className="p-3" />
        </div>
      </div>
    </ContentWrapper>
  );
};

export default SettingsPage;
